module.exports = __webpack_public_path__ + "img/image-1.7435b228.png";